import React, { useState } from "react"
import Fuse from 'fuse.js'
import fuzzysort from 'fuzzysort'
import pluralize from 'pluralize'

const useSearchHook = () => {
  const [boost, setBoost] = useState([])
  const [synonyms, setSynonyms] = useState([])
  const [fuzzIndex, setFuzzIndex] = useState([])

  const fuseOptions = {
    shouldSort: true,
    useExtendedSearch: true,
    threshold: 0.1,
    ignoreDiacritics: true,
    includeScore: true,
    includeMatches: true,
    keys: [
      {
        name: 'tags',
        weight: 1
      },
      {
        name: 'color',
        weight: 2
      },
      {
        name: 'sizes',
        weight: 0.5
      },
      {
        name: 'gender',
        weight: 0.5
      }
    ]
  }

  const setupFuzz = (products) => {
    let fuzzprods = products.map(product => {
      let tags = product.search.map(x => x.replace('womens-',''))
      tags = product.search.map(x => x.replace('mens-',''))
      tags = tags.flatMap(tag => {
        const hassyns = synonyms.filter(x => x.includes(tag))
        return hassyns.length > 0 ? hassyns : tag
      })
      const is_gift = product.handle.includes('gift')

      const sizes_key = {
        'XXS': 'extra extra small',
        'XS': 'extra small', 
        'S': 'small', 
        'M': 'medium', 
        'L': 'large', 
        'XL': 'extra large', 
        'XXL': 'extra extra large', 
        'OS': 'one size'
      }
      let sizes = []
      if (!is_gift && !!product.variants) {
        sizes = compact(Object.keys(product.variants).map(k => !!product.variants[k] ? k : null))
        let needs_text = Object.keys(sizes_key).some(x => sizes)
        if (needs_text) sizes = sizes.concat(sizes.map(x => sizes_key[x]))
      }

      tags = compact([...new Set(tags.flat())])

      return {
        id: product.mid,
        gender: product.gender,
        tags: tags.join(' '),
        sizes: compact(sizes)
      }
    })

    setFuzzIndex(fuzzprods)
  }

  const setupFuse = (products, setFuseIndex) => {
    // setupFuzz(products)
    const docs = products.map(product => {
      let tags = product.search.map(x => x)
      const is_gift = product.handle.includes('gift')

      tags = tags.flatMap(tag => {
        const hassyns = synonyms.filter(x => x.includes(tag))
        return hassyns.length > 0 ? hassyns : tag
      })

      const sizes_key = {
        'XXS': 'extra extra small',
        'XS': 'extra small', 
        'S': 'small', 
        'M': 'medium', 
        'L': 'large', 
        'XL': 'extra large', 
        'XXL': 'extra extra large', 
        'OS': 'one size'
      }
      let sizes = []
      if (!is_gift && !!product.variants) {
        sizes = compact(Object.keys(product.variants).map(k => !!product.variants[k] ? k : null))
        let needs_text = Object.keys(sizes_key).some(x => sizes)
        if (needs_text) sizes = sizes.concat(sizes.map(x => sizes_key[x]))
      }

      tags = tags.flat().map(x => x.replace('womens-',''))
      tags = tags.map(x => x.replace('mens-',''))
      tags = tags.map(x => pluralize.singular(x).toLowerCase())
      tags = [...new Set([...tags, ...sizes])]

      return {
        id: product.mid,
        gender: product.gender,
        tags: compact(tags),
        sizes: compact(sizes)
      }
    })
    setFuseIndex(new Fuse(docs, fuseOptions))
  }

  const getSearchData = async () => {
    const is_stag = process.env.GATSBY_CURR_ENV === 'development'
    let url = is_stag 
      ? 'https://cdn-staging.buckmason.com/search/search-json.json' 
      : 'https://cdn.buckmason.com/search/search-json.json'

    // url = 'https://s3.us-west-1.amazonaws.com/mokah-livestaging/search/search-json.json'

    const res = await fetch(url)
    let data = await res.json()
    const products = uncompData(data)

    if (data.boost.length > 0) setBoost(data.boost)
    if (data.synonyms.length > 0) setSynonyms(data.synonyms)
    
    return {products, callouts: data.callouts}
  }

  const buildVals = (val, fuseIndex, searchType) => {
    let hasSpaces = val.trim().includes(' ')

    let search_q = val
    let val_arr = compact(val.trim().split(' '))

    let curr_gend = searchType
    const gends = ['men', 'mens', "men's", 'women', 'womens', "women's"]
    let has_gend = val_arr.find(x => gends.includes(x.toLowerCase()))
    
    if (has_gend) {
      let search_gend = has_gend.toLowerCase().slice(0,1)
      if (search_gend !== curr_gend) {
        curr_gend = search_gend
      }
      val_arr = val_arr.filter(x => !gends.includes(x.toLowerCase()))
      search_q = val_arr.join(' ')
      if (val_arr.length === 1) hasSpaces = false
    }
    if (val_arr.length < 1 || (val_arr.length === 1 && val_arr[0].length < 3)) {
      return {user: [], fuzzy: []}
    }

    // val_arr = val_arr.map(x => pluralize.singular(x))

    let prods = fuseIndex._docs
    if (!!curr_gend && curr_gend !== 'u') {
      const gends = [curr_gend,'u']
      prods = prods.filter(x => gends.includes(x.gender))
    }
    
    const tees = ['teeshirt','teeshirts','tshirt','tshirts','teshirt']
    const noguess = ['red','green','blue','brown','white','black','grey','gray']
    const tags = [...new Set(prods.flatMap(x => x.tags) )]
    let sing_found = false
    let tagFuse

    if (val_arr.length === 1) sing_found = tags.includes(val_arr[0])

    tagFuse = new Fuse(tags.map(tag => ({ tag })), {
      threshold: 0.35,
      ignoreDiacritics: true,
      includeScore: true,
      keys: ['tag']
    })

    if (val_arr.some(x => tees.includes(x)) || tees.find(x => x.includes(search_q))) {
      val_arr = val_arr.filter(x => !tees.includes(x))
      val_arr.push('tee')
    }

    let user = val_arr.map(x => x)
    let fuzzy = val_arr.map(x => x)

    // if (!hasSpaces && !tees.includes(search_q) && !noguess.includes(search_q)) {
    //   const matches = tagFuse.search(search_q)
    //   fuzzy = matches
    //     .filter(match => match.score < 0.2)
    //     .map(match => match.item.tag)
    // }

    fuzzy = fuzzy.flatMap(tag => {
      const matches = tagFuse.search(tag).filter(match => match.score < 0.3)
      return matches.length > 0 ? matches.map(x => x.item.tag) : tag
    })

    fuzzy = fuzzy.filter(x => !user.includes(x))

    return {user, fuzzy}
  }

  const compact = (arr) => {
    return arr.filter(x => x !== null && x !== undefined && x !== '')
  }

  const searchProds = ({
    val, val_arr, products, fuseIndex, currSort, searchType, isPanel=false, plstest=false, currSizes
  }) => {
    let search_obj = {val, products, fuseIndex, currSort, searchType}

    let user = []
    if (val_arr.user.length > 0) {
      search_obj.vals = val_arr.user
      user = doSearch(search_obj)
      // fuzzSearch(search_obj)
    }
    const user_ids = user.map(x => x.mid)

    let fuzzy = []
    if (val_arr.fuzzy.length > 0) {
      search_obj.vals = val_arr.fuzzy
      fuzzy = doSearch(search_obj)
      fuzzy = fuzzy.filter(x => !user_ids.includes(x.mid))
    }

    let boosts = checkBoost({user, fuzzy})
    user = boosts.user
    fuzzy = boosts.fuzzy
    boosts = boosts.boosts

    let results
    if (currSort !== 'asc') {
      user = sortProds(user, currSort)
      fuzzy = sortProds(fuzzy, currSort)
    } else {
      results = sortProds(boosts.concat(user).concat(fuzzy), currSort)
    }

    if (plstest) {
      let prods = currSort === 'asc' ? results : boosts.concat(user).concat(fuzzy)
      results = plGroup({prods, products, vals: val_arr.user, currSizes})
      return results
    }
    if (currSort === 'asc') return [results]

    results = [user, fuzzy]
    if (boosts.length > 0) results.unshift(boosts)

    return results
  }

  const colors = [
    'red', 'green', 'blue', 'brown', 'tan', 
    'beige', 'offwhite', 'natural', 'white', 
    'black', 'grey', 'gray', 'navy', 'yellow',
    'orange', 'purple'
  ]
  const gend_tags = ['men', 'mens', "men's", 'women', 'womens', "women's"]


  const fuzzSearch = ({vals, products, searchType}) => {
    return 
    let tosearch = fuzzIndex
    const gends = [searchType, 'u']
    if (searchType) tosearch = fuzzIndex.filter(x => gends.includes(x.gender))

    let tt = tosearch.filter(item => {
      let found = false
      for (const tag of item.tags) {
        const match = fuzzysort.single(vals.join(' '), tag)
        if (match && match._score >= -10000) {
          found = { item, score: match._score }
          break;
        }
      }
      return found
    })
    
    let results = fuzzysort.go(vals.join(' '), tosearch, {key: 'tags', threshold: -10000})
    results = results.filter(x => x._score >= -10000)
  }

  const doSearch = ({val, vals, products, fuseIndex, searchType}) => {
    let hasSpaces = val.trim().includes(' ')
    
    const gend_vals = val.trim().split(' ')
    let has_gend = gend_vals.find(x => gend_tags.includes(x.toLowerCase()))
    if (has_gend && gend_vals.length === 2) {
      hasSpaces = false
    }

    let terms_arr = vals.map(x => { return { tags: x} })

    let fuse_obj = {$and: []}
    if (hasSpaces) {
      fuse_obj.$and.push(...terms_arr)
    } else {
      fuse_obj.$and.push({$or: terms_arr})
    }

    // if (searchType) fuse_obj.$and.push( {$or: [{gender: `=${searchType}`}, {gender: `=u`}]} )
    let results = fuseIndex.search(fuse_obj)
    const taggends = ['m','w','u']
    results = results.map(x => {
      return {
        ...x.item,
        score: Math.round((1 - x.score) * 100),
        matches: compact(x.matches.map(i => i.value).filter(i => !taggends.includes(i)))
      }
    })
    // console.log(results)

    const gends = [searchType, 'u']
    if (searchType) results = results.filter(x => gends.includes(x.gender))

    let prods = []
    let some_terms = []
    let no_terms = []

    if (val.includes('shorts') && (!val.includes('slee') && !val.includes('skirt'))) {
      const shorts_skips = ['tee','shirt','teeshirt','tshirt','sleeve','crew']
      results = results.filter(res => !res.tags.some(x => shorts_skips.includes(x)))
    }
    if (vals.includes('shirt') && !val.includes('tee')) {
      const shorts_skips = ['tee','tees']
      results = results.filter(res => !res.tags.some(x => shorts_skips.includes(x)))
    }
    if ((vals.includes('suit') || vals.includes('suite') || vals.includes('suiting')) && !val.includes('swim')) {
      const suit_skips = ['shirting']
      results = results.filter(res => !res.tags.some(x => suit_skips.includes(x)))
    }

    // results.forEach(fuseProd => {
    //   let tag_arr = compact(vals).map(term => {
    //     if (fuseProd.tags.includes(term)) return true 
    //     return !!compact(fuseProd.tags).find(x => x === term || x.slice(0,-1) === term || x.includes(term))
    //   }) 

    //   let prod_data = products.find(x => x.mid === fuseProd.id)
    //   if (!prod_data) return

    //   prod_data = {
    //     ...prod_data,
    //     broken: !!prod_data.broken,
    //     score: fuseProd.score,
    //     matches: fuseProd.matches
    //   }

    //   if (!tag_arr.includes(false) && !tag_arr.includes(null)) {
    //     prod_data.hits = vals.length
    //     prods.push(prod_data)
    //     return
    //   }
    //   if (tag_arr.includes(true)) {
    //     prod_data.hits = tag_arr.filter(x => !!x).length
    //     some_terms.push(prod_data)
    //     return
    //   }

    //   prod_data.hits = 0
    //   no_terms.push(prod_data)
      
    // })
    prods = compact(results.map(fuseProd => products.find(x => x.mid === fuseProd.id)))
    if (val.includes('shorts') && (!val.includes('slee') && !val.includes('skirt'))) {
      prods = prods.filter(x => !x.handle.includes('slim-crew') && !x.handle.includes('easy-crew'))
    }

    return prods.concat(some_terms)
  }

  const checkBoost = ({user, fuzzy}) => {
    const doBoost = (prods) => {
      const fallback = {found: [], prods}

      if (prods.length < 1) return fallback
      const any_boost = boost.some(id => prods.find(x => x.mid === id))
      if (!any_boost) return fallback

      let found = prods.filter(x => boost.includes(x.mid))
      let reg_prods = prods.filter(x => !boost.includes(x.mid))
      found = found.sort((a, b) => boost.indexOf(a.mid) - boost.indexOf(b.mid))
      return {found, prods: reg_prods}
    }

    let boosts
    let user_obj = doBoost(user)
    boosts = user_obj.found

    let fuzz_obj = doBoost(fuzzy)
    boosts = boosts.concat(fuzz_obj.found)
    
    return {boosts: boosts, user: user_obj.prods, fuzzy: fuzz_obj.prods}
  }

  const plGroup = ({prods, products, vals, currSizes}) => {
    const has_color = vals.some(term => colors.includes(term) || colors.includes(term.slice(0,-1)))
    const alt_q = vals.includes('short') || vals.includes('tall')

    let nprods = prods.flat()
    const pl_ids = [...new Set(nprods.map(x => x.pl_id))]

    let pl_groups = pl_ids.map(id => {
      let feats = nprods.filter(x => x.pl_id === id)
      if (feats.length < 1) return null
      if (!has_color && !(currSizes?.length > 0)) feats = feats.slice(0,1)

      const feat_ids = feats.map(x => x.mid)
      const pl_prods = products.filter(x => x.pl_id === id && !feat_ids.includes(x.mid))
      const is_alt = feats.find(x => x.isalt) || pl_prods.find(x => x.isalt)

      let price
      if (feats[0].handle.includes('gift')) {
        price = `25-$1,000`
      } else {
        price = feats[0].price
      }

      return {
        pl_id: id,
        pl_name: feats[0].pl_name,
        is_alt: is_alt,
        gender: feats[0].gender,
        price: price,
        feats: feats,
        products: pl_prods
      }
    })
    pl_groups = compact(pl_groups)
    if (!alt_q) pl_groups = pl_groups.filter(x => !x.is_alt)

    return pl_groups
  }

  const filterSizes = ({results, currSizes, plstest=false, val}) => {
    let new_results
    const vals = val.split(' ')
    const has_color = vals.some(term => colors.includes(term) || colors.includes(term.slice(0,-1)))

    if (results[0].hasOwnProperty('feats')) {
      new_results = results.map(pline => {
        let feats = pline.feats.filter(product => {
          let sizes = compact(Object.keys(product.variants).map(k => !!product.variants[k] ? k : null))
          return currSizes.some(x => sizes.includes(x))
        })
        let products = pline.products.filter(product => {
          let sizes = compact(Object.keys(product.variants).map(k => !!product.variants[k] ? k : null))
          return currSizes.some(x => sizes.includes(x))
        })
        if (!has_color) {
          feats = feats.concat(products)
          products = []
        }

        return {...pline, feats, products}
      })
      new_results = new_results.filter(x => x.feats.length > 0)
    } else {
      new_results = results.flat().filter(product => {
        let sizes = compact(Object.keys(product.variants).map(k => !!product.variants[k] ? k : null))
        return currSizes.some(x => sizes.includes(x))
      })
      new_results = [new_results]
    }

    return new_results
  }

  const sortProds = (products, currSort, useHits=false) => {
    let prods = products
    if (currSort === 'rec') {
      if (!useHits) {
        prods = prods.sort((a, b) => {
          if (a.broken !== b.broken) return a.broken - b.broken
          return b.pub - a.pub
        })
      } else {
        prods = prods.sort((a, b) => {
          if (a.hits !== b.hits) return b.hits - a.hits
          if (a.broken !== b.broken) return a.broken - b.broken 
          return b.pub - a.pub
        })
      }
    } else if (currSort === 'best') {
      if (!useHits) {
        prods = prods.sort((a, b) => {
          if (a.broken !== b.broken) return a.broken - b.broken
          return a.best - b.best
        })
      } else {
        prods = prods.sort((a, b) => {
          if (a.hits !== b.hits) return b.hits - a.hits
          if (a.broken !== b.broken) return a.broken - b.broken 
          return a.best - b.best
        })
      }
    } else {
      prods = prods.sort((a, b) => a.price - b.price)
    }
    
    return prods
  }

  const uncompData = (data) => {
    const tags = data.tags
    let prods = data.products.map(prod => {
      const newobj = {
        mid: prod.mid,
        pl_id: prod.pid,
        shop_id: prod.sid,
        handle: prod.h,
        title: prod.t,
        pub: prod.pb,
        pl_name: prod.pn,
        color: prod.c,
        gender: prod.g,
        pl_colors: prod.pc,
        media: prod.m,
        available: !!prod.a,
        price: prod.pr,
        best: prod.be,
        broken: !!prod.br,
        search: prod.sr,
        sku: prod.sk,
        callouts: prod.ca || [],
        isalt: !!prod.isa,
        altcuts: prod.ac,
        variants: prod.v
      }
      newobj.search = newobj.search.map(x => tags[x])
      if (typeof newobj.handle !== 'string') {
        newobj.handle = newobj.handle.map(x => tags[x]).join('-')
      }
      if (typeof newobj.title !== 'string') {
        newobj.title = newobj.title.map(x => tags[x]).join(' ')
      }
      if (typeof newobj.pl_name !== 'string') {
        newobj.pl_name = newobj.pl_name.map(x => tags[x]).join(' ')
      }
      return newobj
    })
    return prods
  }

  const searchPages = (pages) => {
    // // const pages_edited = pages.map(x => {
    // //   const name_arr = [...new Set((`${x.handle}${x.add ? `-${x.add}` : ''}`).replace(' ', '-').toLowerCase().split('-'))]
    // //   x['search'] = name_arr
    // // })
    // let page_search = pages.filter( page => {
    //   const search = !_.map(val_arr, x => page.search.includes(x) || _.map(page.search, y => y.includes(x)).includes(true) ).includes(false)
    //   return search ? page : false
    // })
    // if (curr_gender) {
    //   page_search = _.filter(page_search, x => x.gender === curr_gender)
    // }
    // if (!curr_gender && curr_page) {
    //   if ( curr_page === 'page' ) {
    //     page_search = _.filter(page_search, x => x.type !== 'store' && x.type !== 'collection')
    //   } else {
    //     page_search = _.filter(page_search, x => x.type === curr_page)
    //   }
    // }
    // return page_search
  }

  const saveSearch = (obj, vals) => {
    obj['val_arr'] = vals
    localStorage.setItem('search', JSON.stringify(obj))

    return true
  }

  const getSearch = () => {
    if (!localStorage.getItem('search')) return false
    const obj = JSON.parse(localStorage.getItem('search'))
    return obj
  }

  return { getSearchData, setupFuse, buildVals, searchProds, filterSizes, searchPages, saveSearch, getSearch }
};

export default useSearchHook
